export const SIZE = [
  'medium',
  'large'
]
